import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src3398630750/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Terms and conditions applicable to all .info registrations</h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  .INFO DOMAIN NAME HOLDER ("Registrant") consents to the use, copying,
  distribution, publication, modification and other processing of Registered
  Name Holder's Personal Data by the Registry Operator and its designees and
  agents in a manner consistent with the purpose specified pursuant to the
  Registrar's agreement with the Registry; submits to proceedings commenced
  under ICANN's UDRP located at{' '}
  <a href="http://www.icann.org/udrp/udrp.htm" target="_blank">
    http://www.icann.org/udrp/udrp.htm
  </a>
  . The Registrant acknowledges that Registry Operator will have no liability of
  any kind for any loss or liability resulting from the proceedings and
  processes relating to the Domain Name Registration.
    </p>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      